<kendo-chat
  [messages]="_communications"
  [authorId]="currentUserId"
  [showAvatar]="true"
  [showUsername]="true"
  timestampVisibility="always"
  [allowMessageCollapse]="true"
  placeholder="Type a message..."
  (sendMessage)="onSendMessage($event)"
  (executeAction)="onAction($event)">

  <!-- Custom message content template: render @mentions as styled spans -->
  <ng-template kendoChatMessageContentTemplate let-message>
    <span [innerHTML]="parseMentions(message.text)"></span>
  </ng-template>

  <!-- Custom message box template: textarea with @mention support -->
  <ng-template kendoChatMessageBoxTemplate>
    <div class="mention-message-box">
      <!-- Mention dropdown (positioned above the input) -->
      <div class="mention-dropdown-container" *ngIf="showMentionDropdown">
        <ul class="mention-dropdown">
          <li
            *ngFor="let user of filteredMentionUsers"
            class="mention-dropdown-item"
            (mousedown)="onMentionSelect(user); $event.preventDefault()">
            <span class="mention-user-avatar" *ngIf="user.avatarUrl">
              <img [src]="user.avatarUrl" [alt]="user.name" />
            </span>
            <span class="mention-user-avatar mention-user-initials" *ngIf="!user.avatarUrl">
              {{ user.name.charAt(0).toUpperCase() }}
            </span>
            <span class="mention-user-name">{{ user.name }}</span>
          </li>
        </ul>
      </div>

      <!-- Custom textarea input -->
      <div class="mention-input-row">
        <textarea
          #chatTextarea
          class="mention-textarea k-input k-textarea"
          [(ngModel)]="messageText"
          (keyup)="onMentionKeyup($event)"
          (keydown)="onCustomKeyDown($event)"
          placeholder="Type a message... Use @ to mention someone"
          rows="2">
        </textarea>
        <button
          class="mention-send-btn k-button k-button-solid k-button-solid-primary"
          [disabled]="!messageText?.trim()"
          (click)="sendMessage()"
          title="Send message">
          <span class="k-icon k-font-icon k-i-arrow-right"></span>
          Send
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template kendoChatAttachmentTemplate let-att>
    <ng-container *ngIf="att.contentType">
      <img class="image-class" [src]="att.content" draggable="false" />
    </ng-container>
  </ng-template>
</kendo-chat>